<mat-toolbar color="accent">Romexis Bridge Settings</mat-toolbar>

<div class="flex flex-col gap-4 p-4">
  <pr-information-box>
    Configure Romexis Bridge settings depending on your installed version of
    Romexis. Use Legacy mode if you experience issues on specific workstations.
  </pr-information-box>

  <div class="flex items-center justify-between">
    <span class="font-medium opacity-90">Apply To All:</span>
    <div class="flex items-center gap-4">
      @for (option of configOptions; track option.type) {
        <button
          mat-stroked-button
          [matTooltip]="option.description"
          (click)="applyToAll(option.type)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  </div>

  <mat-divider />

  @for (form of formArray; track form.value.device.ref.path) {
    <form class="flex items-center gap-4" [formGroup]="form">
      <span class="w-32 truncate font-medium opacity-90">
        {{ form.value.device.name }}:
      </span>

      <mat-form-field subscriptSizing="dynamic" class="flex-1">
        <mat-label>Version Configuration</mat-label>
        <mat-select formControlName="configuration">
          <mat-select-trigger>
            {{ form.value.configuration | map: getConfigurationLabel : this }}
          </mat-select-trigger>
          @for (option of configOptions; track option.type) {
            <mat-option [value]="option.type">
              <div class="flex flex-col py-1">
                <span>{{ option.label }}</span>
                <span class="mt-0.5 text-sm opacity-70">
                  {{ option.description }}
                </span>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Close</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</div>
